export const pages = {
    dashboard: "Dashboard",
    calendar: "Calendar",
    message: "Messages",
    messageDetails: "Message details",
    assignments: "Assignments",
    timetable: "Timetable",
    announcements: "Announcements",
    announcementDetails: "Announcement details",
    exams: "Exams",
    examDetails: "Exam details",
    onlineMeetings: "Online Meetings",
    attendance: "Attendance",
    fees: "Fees",
    teachersComments: "Teachers comments",
    teachersCommentDetails: "Teachers comment details",
    studentHistory: "Student history",
    gallery: "Gallery",
    busPass: "Bus pass",
    lessonNotes: "Lesson notes",
    idCard: "ID card",
    myAccount: "My account",
    previousQuestionPapers: "Previous question papers",
    pickupAssistant: "Pickup assistant",
    emergencyContact: "Emergency contact"
}